<script setup lang="ts">
import type { SliderT } from '~/schema/types'

const { public: config } = useRuntimeConfig()
const items = ref<Omit<SliderT, 'created_at' | 'updated_at'>[]>()

onMounted(() => {
  $fetch('/intl-api/slider').then((data) => {
    items.value = data || []
  })
})
</script>
<template>
  <div
    v-if="items && items?.length === 3"
    class="flex flex-col gap-11 py-7 lg:py-12 relative bg-surface-container-low"
  >
    <UiContainer class="grid gap-6 lg:gap-10">
      <h2
        class="text-2xl leading-7 lg:text-4xl font-bold lg:text-center text-on-secondary-container font-display"
      >
        Promo, Event & Update Terbaru
      </h2>
      <UiCard class="rounded-3xl">
        <div
          class="overflow-x-auto flex lg:overflow-x-visible lg:grid gap-3 lg:grid-cols-3"
        >
          <NuxtLink
            v-for="item in items"
            :key="item.id"
            :to="$utm.utmUrl(item.url)"
            :target="item.url.includes(config.appUrl) ? '_self' : '_blank'"
            class="rounded-xl shrink-0 w-full overflow-hidden hover:scale-102 transition-all"
          >
            <NuxtImg
              :src="item.image"
              :alt="item.name"
              width="402.91px"
              height="226.71px"
              class="w-full"
            />
          </NuxtLink>
        </div>
      </UiCard>
    </UiContainer>
  </div>
</template>
